import React, { useEffect, useState } from "react";
import { AutomationRuleConditionTypes, ConditionModel } from "../../models/automations.model";
import { buttonLabels } from "../shared/constants";
import { AddButtonIcon, DeleteButtonIcon, InformationDarkScheduleIcon } from "../../icon";
import { ChannelType, ConversationType } from "../../models/conversations";
import { Autocomplete, Chip, FormHelperText, TextField } from "@mui/material";


interface IProps {
    conditions: any[];
    handleSelectedOptions: (value) => void;
    channel: number;
    conditionErrors: boolean;
    selectedConditions?: ConditionModel[];
}


const AddConditionCardComponent: React.FC<IProps> = (props: IProps) => {

    const [selectedConditions, setSelectedConditions] = useState<ConditionModel[]>([])

    const MessageActivityOptions = props.channel === ChannelType.LIVE_CHAT ? ["MessageActivityMoreThan5MINS", "MessageActivityMoreThan10MINS"] : ["InstantMessage", "MessageActivityMoreThan5MINS", "MessageActivityMoreThan10MINS", "MessageActivityMoreThan30MINS", "MessageActivityMoreThan6Hours", "MessageActivityMoreThan12Hours"]

    const Locations = ["India", "Andorra", "United Arab Emirates", "Afghanistan", "Antigua and Barbuda", "Anguilla", "Albania", "Armenia", "Netherlands Antilles", "Angola", "Antarctica", "Argentina", "American Samoa", "Austria", "Australia", "Aruba", "Aland Islands (Finland)", "Azerbaijan", "Bosnia & Herzegovina", "Barbados", "Bangladesh", "Burundi", "Benin", "Saint Barthelemy", "Bermuda", "Brunei", "Bolivia", "Bonaire, Sint Eustatius and Saba", "Brazil", "The Bahamas", "Bhutan", "Bouvet Island", "Botswana", "Belarus", "Ivory Coast", "Cook Islands", "Chile", "Cameroon", "China", "Colombia", "Costa Rica", "Cuba", "Cape Verde", "Curacao", "Christmas Island", "Cyprus", "Czech Republic", "Germany", "Djibouti", "Ethiopia", "Finland", "Fiji", "Falkland Islands", "Federated States of Micronesia", "Faroe Islands", "France", "Gabon", "United Kingdom", "Guatemala", "Guam", "Guinea-Bissau", "Guyana", "Hong Kong", "Heard Island and McDonald Islands", "Honduras", "Croatia", "Iraq", "Iran", "Iceland", "Italy", "Jersey", "Jamaica", "Jordan", "Japan", "Kenya", "Saint Kitts and Nevis", "North Korea (DPRK)", "South Korea", "Kuwait", "Cayman Islands", "Kazakhstan", "Laos", "Lebanon", "Saint Lucia", "Liechtenstein", "Sri Lanka", "Libya", "Morocco", "Monaco", "Moldova", "Montenegro", "Saint Martin", "Madagascar", "Marshall Islands", "Macedonia", "Mali", "Burma (Myanmar)", "Mongolia", "Malawi", "Mexico", "Malaysia", "Mozambique", "Namibia", "New Caledonia", "Niger", "Norfolk Island", "Nigeria", "Nicaragua", "Netherlands", "St. Helena", "Slovenia", "Svalbard and Jan Mayen", "Slovakia", "Sierra Leone", "San Marino", "Senegal", "Somalia", "Suriname", "South Sudan", "Swaziland", "Turks and Caicos Islands", "Chad", "French Southern and Antarctic Lands", "Togo", "Thailand", "Tajikistan", "Tokelau", "Timor-Leste", "Turkmenistan", "Tunisia", "Tonga", "Ukraine", "Uganda", "United States Minor Outlying Islands", "United States of America", "Uruguay", "Uzbekistan", "Vatican City", "Saint Vincent and the Grenadines", "Venezuela", "British Virgin Islands", "United States Virgin Islands", "Vietnam", "Vanuatu", "Wallis and Futuna", "Samoa", "Kosovo", "Yemen", "Mayotte", "South Africa", "Zambia", "Zimbabwe"]

    const StatusOptions = ["Away", "Avaialable"]

    const GenderOptions = ["Male", "Female", "Other"]

    const BusinessInfoOptions = ["hours", "contact inforamation", "location"]

    useEffect(() => {
        if (!!props.conditionErrors) {
            setSelectedConditions(selectedConditions.map(x => {
                return {
                    id: x.id,
                    condition: x.condition,
                    value: x.value,
                    conditionError: x.condition !== null ? "" : `condition cannot be blank`,
                    valueError: x.condition !== null ? x.value.toString() === "" ? `${x.condition.Name} cannot be blank` : "" : ""
                }
            }))
        }
    }, [props.conditionErrors])

    useEffect(() => {
        props.handleSelectedOptions(selectedConditions)
    }, [selectedConditions])

    useEffect(() => {
        setSelectedConditions([])
        props.handleSelectedOptions([])
    }, [props.channel])

    useEffect(() => {
        if (!!props.selectedConditions?.length) {
            setSelectedConditions((props.selectedConditions).map(x => {
                return {
                    id: x.id,
                    condition: x.condition,
                    value: x.value,
                    conditionError: "",
                    valueError: "",
                }
            }))
        }
        else {
            const id = new Date().valueOf();
            const newBlankCondition = {
                id: id,
                condition: null,
                value: [],
                conditionError: "",
                valueError: ""
            };
            setSelectedConditions([newBlankCondition]);
        }
    }, [])

    const handleAddCard = (event) => {
        const id = new Date().valueOf();
        setSelectedConditions([...selectedConditions, { id: id, condition: null, value: [], conditionError: "", valueError: "" }])
    }

    const handleRemoveCard = (event, id) => {
        let newConditions = [...selectedConditions]
        newConditions = newConditions.filter(x => x.id !== id)
        setSelectedConditions([...newConditions])
    }

    const handleSelectedConditions = (event, value, id) => {
        if (value) {
            const newConditions = [...selectedConditions]
            newConditions.find(x => x.id === id).condition = value
            newConditions.find(x => x.id === id).value = []
            newConditions.find(x => x.id === id).conditionError = ""
            newConditions.find(x => x.id === id).valueError = ""
            setSelectedConditions(newConditions)
        }
        else {
            const newConditions = [...selectedConditions]
            newConditions[newConditions.findIndex(x => x.id === id)] = { id: id, condition: null, value: [], valueError: "", conditionError: "condition cannot be blank" }
            setSelectedConditions(selectedConditions.length > 1 ? newConditions : [{ id: id, condition: null, value: [], valueError: "", conditionError: "condition cannot be blank" }])
        }
    }

    const handleKeyDown = (event, conditionValue, id) => {
        if (conditionValue !== AutomationRuleConditionTypes.KEYWORDS) {
            event.preventDefault();
        }
        else if (conditionValue === AutomationRuleConditionTypes.KEYWORDS && event.key === "Enter") {
            handleBlur(event, id)
        }
    }

    const handleValueError = (conditionValue) => {
        switch (conditionValue) {
            case AutomationRuleConditionTypes.LOCATION:
                return "Locations cannot be blank"
            case AutomationRuleConditionTypes.MESSAGE_ACTIVITY:
                return "Message Inactivity cannot be blank"
            case AutomationRuleConditionTypes.KEYWORDS:
                return "Atleast one keyword is required"
            case AutomationRuleConditionTypes.STATUS:
                return "Status cannot be blank"
            case AutomationRuleConditionTypes.BUSINESS_INFORMATION:
                return "BusinessInfo cannot be blank"
            case AutomationRuleConditionTypes.GENDER:
                return "Gender cannot be blank"
        }
    }

    const handleOnChange = (event, value, id) => {

        const newConditions = [...selectedConditions]
        const conditionValue = newConditions.find(x => x.id === id).condition.Value
        if (conditionValue !== AutomationRuleConditionTypes.KEYWORDS) {
            newConditions.find(x => x.id === id).value = value === null ? [] : [value].filter(x => x.trim() !== "")
            newConditions.find(x => x.id === id).valueError = newConditions.find(x => x.id === id).value.toString() === "" ? handleValueError(conditionValue) : ""
            setSelectedConditions(newConditions)
        }
        else {
            let selectedKeywords = value.filter((x, i) => typeof x !== "string");
            selectedKeywords.filter((x, index) => selectedKeywords.findIndex(y => y.ID === x.ID) === index)
            newConditions[newConditions.findIndex(x => x.id === id)].value = value.filter(x => x.trim() !== "")
            newConditions[newConditions.findIndex(x => x.id === id)].valueError = !!value ? value[0] !== undefined || null ? "" : handleValueError(conditionValue) : handleValueError(conditionValue)
            setSelectedConditions(newConditions)
        }
    }

    const handleOptions = (conditionValue) => {
        switch (conditionValue) {
            case AutomationRuleConditionTypes.LOCATION:
                return Locations
            case AutomationRuleConditionTypes.MESSAGE_ACTIVITY:
                return MessageActivityOptions
            case AutomationRuleConditionTypes.KEYWORDS:
                return []
            case AutomationRuleConditionTypes.STATUS:
                return StatusOptions
            case AutomationRuleConditionTypes.BUSINESS_INFORMATION:
                return BusinessInfoOptions
            case AutomationRuleConditionTypes.GENDER:
                return GenderOptions
        }
    }

    const handleKeywords = (event, valueslist, id) => {
        let selectedKeywords = valueslist.filter((x, i) => typeof x !== "string");
        selectedKeywords.filter((x, index) => selectedKeywords.findIndex(y => y.ID === x.ID) === index)
        const newConditions = [...selectedConditions]
        newConditions[newConditions.findIndex(x => x.id === id)].value = valueslist.filter((value, index, array) => array.indexOf(value) === index).filter(value => value !== "")
        newConditions[newConditions.findIndex(x => x.id === id)].valueError = !!valueslist ? "" : "Atleast one keyword is required"
        setSelectedConditions(newConditions)
    }

    const handleBlur = (event: any, id) => {
        handleKeywords(event, [...selectedConditions.find(x => x.id === id).value, event.target?.value], id)
    }

    const handleKeywordSeparatedByComa = (valuelist) => {

        const returnList = valuelist?.filter(x => x.trim() !== "").map(x => x.split(",").filter(x => x.trim() !== ""))
        return [].concat(...returnList).filter((value, index, array) => array.indexOf(value) === index)
    }

    return <div>
        {!!selectedConditions && selectedConditions.map(x =>
            <div className="d-flex justify-center align-center flex-direction br-1">
                <div className="w-p-100 mx-auto h4-semibold h-5 d-flex align-center color-primary-light">
                    Condition
                </div>
                <div className="w-p-100 mx-auto bg-color-secondary">
                    <Autocomplete
                        className={`w-p-100 mx-auto ${!!x.conditionError ? "" : "mb-2"} `}
                        value={x.condition}
                        disableClearable
                        onChange={(event, value) => handleSelectedConditions(event, value, x.id)}
                        options={props.conditions.filter(x => !selectedConditions.map(x => x.condition?.Name).includes(x.Name))}
                        getOptionLabel={(condition) => condition.Name}
                        classes={{
                            option: "custom-option",
                            input: `color-text-field-font h4-regular`
                        }}
                        renderInput={(params) =>
                            <TextField
                                {...params}
                                label="Action"
                                placeholder="Select Condition"
                                required
                                variant='outlined'
                                size='small'
                                onKeyDown={(e) => handleKeyDown(e, x.condition?.Name, x.id)}
                                inputProps={{ ...params.inputProps, readOnly: true }}

                                InputLabelProps={{
                                    shrink: true,
                                }} />}
                    />
                    <FormHelperText className="h6-regular color-primary-danger t-align-right mr-2">
                        {x.conditionError}
                    </FormHelperText>

                    {!!x.condition &&
                        <>
                            <div className="w-p-100 d-flex flex-direction">
                                {x.condition.Value === AutomationRuleConditionTypes.KEYWORDS &&
                                    <div className="d-flex align-center">
                                        <InformationDarkScheduleIcon />
                                        <span className={"footnote-medium color-conv-date w-p-100 mx-auto ml-1"}>Message text contains all the keywords.</span>
                                    </div>
                                }
                                {x.condition.Value === AutomationRuleConditionTypes.BUSINESS_INFORMATION && <div className="d-flex align-center">
                                    <InformationDarkScheduleIcon />
                                    <span className={"footnote-medium color-conv-date w-p-100 mx-auto ml-1"}>When contact asked for business information.</span> </div>}
                                {x.condition.Value === AutomationRuleConditionTypes.STATUS && <div className="d-flex align-center">
                                    <InformationDarkScheduleIcon />
                                    <span className={"footnote-medium color-conv-date w-p-100 mx-auto ml-1"}>Channel account status.</span> </div>}
                                {x.condition.Value === AutomationRuleConditionTypes.MESSAGE_ACTIVITY && <div className="d-flex align-center">
                                    <InformationDarkScheduleIcon />
                                    <span className={"footnote-medium color-conv-date w-p-100 mx-auto ml-1"}>Time since customer last contacted.</span> </div>}
                                <Autocomplete
                                    onBlur={(e) => handleBlur(e, x.id)}
                                    freeSolo={false}
                                    disableClearable
                                    multiple={x.condition.Value == AutomationRuleConditionTypes.KEYWORDS}
                                    className={`mt-2 w-p-100 mx-auto ${!!x.valueError ? "" : "mb-2"}`}
                                    value={x.condition.Value === AutomationRuleConditionTypes.KEYWORDS ? handleKeywordSeparatedByComa(x.value) : !!x.value[0] ? x.value[0] : ""}
                                    onChange={(event, value) => handleOnChange(event, value, x.id)}
                                    options={handleOptions(x.condition.Value)}
                                    getOptionLabel={(option) => option}
                                    classes={{
                                        option: "custom-option",
                                        input: `color-text-field-font h4-regular`
                                    }}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip
                                                classes={{
                                                    colorPrimary: "custom-color-chip-1"
                                                }}
                                                color={"primary"}
                                                label={option}
                                                {...getTagProps({ index })}
                                            />
                                        ))
                                    }
                                    renderInput={(params) =>
                                        <TextField
                                            {...params}
                                            name={x.condition.Name}
                                            label={x.condition.Name}
                                            placeholder={`${x.condition.Value === AutomationRuleConditionTypes.KEYWORDS ? "Enter" : "Select"} ${x.condition.Name}`}
                                            required
                                            variant='outlined'
                                            size='small'
                                            onKeyDown={(e) => handleKeyDown(e, x.condition.Value, x.id)}
                                            inputProps={{ ...params.inputProps, readOnly: x.condition.Value === AutomationRuleConditionTypes.KEYWORDS ? false : true }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />}
                                />
                            </div>
                            <FormHelperText className="h6-regular color-primary-danger t-align-right mr-2">
                                {x.valueError}
                            </FormHelperText>
                        </>
                    }

                    {/* <div className="w-p-100 mb-2 mx-auto h-5 h4-regular bg-color-add-rule-remove-condition br-2">
                        <button className="w-p-100 h-p-100" onClick={(event) => handleRemoveCard(event, x.id)}>
                            <DeleteButtonIcon className="pr-1" />
                            {buttonLabels.REMOVE_CONDITION}</button>
                    </div> */}
                </div>
            </div>
        )}
        {!!selectedConditions && selectedConditions.length < ((props.channel === ConversationType.LIVE_CHAT || props.channel === ConversationType.GOOGLE_BUSINESS_MESSAGES) ? 1 : props.conditions.length) &&
            <div className="w-p-100 mt-1 mb-1 mx-auto h-5 h4-bold">
                <button className="w-p-100 h-p-100 add-more-button-border" onClick={handleAddCard} >
                    <AddButtonIcon className="pr-1" />
                    {buttonLabels.ADD_MORE_CONDITIONS}</button>
            </div>
        }
    </div>
}


export default AddConditionCardComponent;